// Blog posts, newest first. To add a post, add an object like:
//
// {
//   slug: "my-first-post",          // used in the URL: #/blog/my-first-post
//   title: "My first post",
//   date: "2026-10-05",             // YYYY-MM-DD
//   summary: "One line shown in the post list.",
//   body: `First paragraph.
//
// Second paragraph. Separate paragraphs with a blank line.`,
// },

const posts = [];

export default posts;
